import HeaderMenu from '@/components/header-menu';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../providers/theme-provider';
import { AnimatedLayout } from './animated-layout';

export default function Layout({ children }: { children: React.ReactNode }) {
  const { logo } = useTheme();
  return (
    <>
      <header className="sticky top-0 z-50 w-full flex px-6 border-b bg-background backdrop-blur ">
        <div className="flex items-center gap-2 font-bold">
          <Link to="/" className="text-white">
            <img src={logo} alt="Rise logo" className="object-contain h-16 w-16 " />
          </Link>
        </div>
        <div className="flex  items-center justify-end ml-auto">
          <HeaderMenu />
        </div>
      </header>
      <main className="flex-1 md:p-6 p-4 max-w-screen-xl mx-auto">
        <AnimatedLayout>{children}</AnimatedLayout>
      </main>
    </>
  );
}
